<ngx-simplebar [options]="{ autoHide: false }" class="widget p-3 tenantDetailsContainer">
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex h-full justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else if (assets()) {
    <p-table
      #dt2
      [columns]="selectedCols"
      [value]="assets()!"
      [tableStyle]="{ 'min-width': '50rem' }"
      [globalFilterFields]="getFilterFields(selectedCols)"
      class="tableHeaderAlignTop mb-3 fullTable"
      [scrollable]="true"
    >
      <ng-template #caption>
        <div class="flex justify-content-between align-items-center gap-2">
          <span>{{ "gate_administration.asset_types.customers" | translate }}</span>
          <div class="flex justify-content-end gap-2 align-items-center">
            <app-svg-icon
              id="tenantSettingsButton"
              class="pointer"
              iconName="cog"
              iconColor="primary"
              (click)="onTenantSettingsClick()"
              *appHasPermission="{
                permissions: [permissions.allPermissions.TENANT_SETTINGS_UPDATE],
              }"
            >
            </app-svg-icon>
            <app-svg-icon
              id="tenantUsersButton"
              class="pointer"
              iconName="customer"
              iconColor="primary"
              (click)="onUsersClick()"
              *appHasPermission="{
                permissions: [permissions.allPermissions.USER_READ],
              }"
            >
            </app-svg-icon>
            <app-svg-icon
              id="addCustomerButton"
              class="pointer"
              iconName="plus"
              iconColor="primary"
              (click)="onCreateClick()"
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_MASTER_DATA_CREATE],
              }"
            >
            </app-svg-icon>
            <input
              pInputText
              type="text"
              (input)="filterGlobal(dt2, $event)"
              [placeholder]="translate.instant('common.search')"
            />
          </div>
        </div>
      </ng-template>
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field">
              {{ col.header | translate }}
              <p-sortIcon [field]="col.field" />
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr>
          @for (col of columns; track col) {
            <td>
              @if (col.subField) {
                {{ rowData[col.field][col.subField] }}
              } @else {
                {{ rowData[col.field] | yesNo }}
              }
            </td>
          }
          <td class="flex gap-3 justify-content-end">
            <app-svg-icon
              *appHasPermission="{
                permissions: [permissions.allPermissions.USER_READ],
              }"
              class="pointer"
              iconName="customer"
              iconColor="primary"
              (click)="onUsersClick(rowData)"
              [id]="'usersButton' + rowData['id'].toString()"
            ></app-svg-icon>
            <app-svg-icon
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_MASTER_DATA_UPDATE],
              }"
              class="pointer"
              iconName="edit"
              iconColor="primary"
              (click)="onEditClick(rowData['id'])"
              [id]="'editCustomerButton' + rowData['id'].toString()"
            ></app-svg-icon>

            <app-svg-icon
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_COMPONENT_DELETE],
              }"
              class="pointer"
              iconName="trash"
              iconColor="primary"
              (click)="onDeleteClick($event, rowData['id'])"
              [id]="'deleteCustomerButton' + rowData['id'].toString()"
            ></app-svg-icon>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
  <div
    class="p-3"
    *appHasPermission="{
      permissions: [permissions.allPermissions.INSPECTION_REPORT_READ],
    }"
  >
    <div class="flex justify-content-start align-items-center gap-2 mb-4">
      <span class="list-title font-semibold">
        {{ "protocols.protocols_title" | translate }}
      </span>
      <app-svg-icon
        iconName="info-circle"
        tooltipPosition="bottom"
        [pTooltip]="translate.instant('protocols.hint')"
        iconColor="secondary"
        class="flex"
      >
      </app-svg-icon>
    </div>
    <div class="protocolsList">
      @for (protocol of protocols(); track protocol.id) {
        <app-document-list-item [config]="protocol"></app-document-list-item>
        <!-- {{ protocol.url }} -->
      } @empty {
        <span class="font-italic"> {{ "protocols.no_protocols" | translate }}</span>
      }
    </div>
  </div>
</ngx-simplebar>
